import React from "react";
import { useState } from "react";

import "../../Styles/LoadingLeft.css";

const LoadingLeft = ({ percent }) => {
    const [isOpenProgressBar, setIsOpenProgressBar] = useState(false);

    // ============================================================

    return (
        <div
            className={`LoadingLeft_wrapper number-font ${
                isOpenProgressBar ? "LoadingLeft_wrapper-show" : ""
            }`}
        >
            <img
                src="/imgs/Book/Book-progressbar-handler.svg"
                alt="handler icon"
                className="LoadingLeft_handler"
                onClick={() => {
                    setIsOpenProgressBar(!isOpenProgressBar);
                }}
            />
            <div className="LoadingLeft_inside">
                <div className="LoadingLeft_inside-loading">
                    <div className="LoadingLeft_inside-loading-1">
                        <div
                            className="LoadingLeft_inside-loading-2"
                            style={{ height: `${percent}%` }}
                        ></div>
                    </div>
                </div>
            </div>
            <div className="LoadingLeft_inside-loading-bottom">
                <p className="LoadingLeft_inside-loading-bottom-percent number-font">
                    %{percent}
                </p>
                <p className="LoadingLeft_inside-loading-bottom-text">
                    تکمیل شده
                </p>
            </div>
        </div>
    );
};
export default LoadingLeft;
